export default {
  contacts: [],
  loadingContacts: false,
  loadingContactsFailed: false,
  loadingContactsSucceeded: false,
  loadingContactsErrors: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/contacts/state.js